import { isNotNullOrUndefined } from "@/app/apiutils";
import Guid from "@/app/types/common/guid";

export const getOneOrManyQueryValuesAsArray = (
  queryValue: string | (string | null)[]
): string[] => {
  return (queryValue instanceof Array ? queryValue : [queryValue]).filter(
    isNotNullOrUndefined
  );
};

// Enums use static function declarations which TS can't add to interfaces, so accept any for now
export const parseEnumArrayQuery = (
  queryValue: string | (string | null)[],
  enumType: any
): any[] => {
  return getOneOrManyQueryValuesAsArray(queryValue)
    .map((enumKey) =>
      !Number.isNaN(enumKey) ? enumType.getByKey(Number(enumKey)) : null
    )
    .filter(isNotNullOrUndefined);
};

export const parseGuidArrayQuery = (
  queryValue: string | (string | null)[]
): Guid[] => {
  return getOneOrManyQueryValuesAsArray(queryValue)
    .map((guidString) => Guid.tryParse(guidString))
    .filter(isNotNullOrUndefined);
};
